import React from 'react';
import { Referrer } from "../typings";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import { useNavigate } from "react-router-dom";

interface Props {
    referrer: Referrer;
}

function ReferrerRow(props: Props) {
    const navigate = useNavigate();

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 2}}>{props.referrer.email}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.referrer.confirmed}/{props.referrer.total}</div>
            <Menu>
                <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                <MenuItems
                    className="menu-box"
                    anchor="bottom"
                >
                    <MenuItem>
                        <div className="menu-item" onClick={() => navigate(`/referrer/${props.referrer.id}`)}>
                            View
                        </div>
                    </MenuItem>
                </MenuItems>
            </Menu>
        </div>
    );
}

export default ReferrerRow;
